import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/seo";

export default function NotFoundPage() {
  usePageMeta("Página não encontrada");
  return (
    <div className="bb-container py-28 text-center" data-testid="not-found-page">
      <p className="bb-eyebrow mb-4">Erro 404</p>
      <h1 className="font-serif text-[2.6rem] sm:text-6xl">Esta página perdeu-se no novelo.</h1>
      <Link to="/loja" className="bb-btn-primary mt-10">Voltar à loja</Link>
    </div>
  );
}
